<template>
  <wrap-container class="cascade w50">
    <p class="header">
      <strong>Felicitaciones {{ nombre }},</strong><br />
      ¡{{ sexo }} a BBVA!
    </p>
    <p class="titulo-detalle">Próximos pasos</p>
    <offer-group
      class="og"
      label-color="white"
      item-color="white"
      :numeric="true"
      v-on:showModal="showModal()"
      @openLink="solicitarTurno"
    >
      <offer-element
        v-for="step in nextSteps"
        :key="step.label"
        label-light="true"
        :buttonLabel="step.buttonLabel"
        :buttonLink="step.buttonLink"
        :detail="step.detail"
        :label="step.label"
        :cbu="step.cbu ? nroCBU : null"
        :modal="step.modal"
      />
    </offer-group>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import OfferElement from "@/components/core/OfferElement";
import OfferGroup from "@/components/core/OfferGroup";
import { DO_SOLICITAR_TURNO } from "../../../config/constants/action-types";

const campania = _BBVA_MOTOR || "ofertaNomina";

export default {
  name: "CajaAhorroNextSteps",
  components: { WrapContainer, OfferElement, OfferGroup },
  data() {
    return {
      nextSteps: require(`@/config/brands/${campania}.js`).proximosPasos
    };
  },
  methods: {
    showModal() {
      this.showModalClaveUsuario = true;
    },
    solicitarTurno() {
      this.$store.dispatch(DO_SOLICITAR_TURNO);
    }
  },
  computed: {
    nombre() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.nombre) {
        return consulta.nombre;
      }
      return "";
    },
    sexo() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.sexo === "F") {
        return "Bienvenida";
      }
      return "Bienvenido";
    },
    email() {
      let consulta = this.$store.getters.getConsulta();
      if (consulta && consulta.email) {
        return consulta.email;
      }
      return "";
    },
    nroCBU() {
      return this.$store.getters.getCBU();
    }
  }
};
</script>

<style scoped>
p.header {
  font-size: 26px;
}

p.titulo-detalle {
  font-size: 20px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}

@media screen and (min-width: 600px) {
  .w50:first-child {
    padding-right: 20px;
  }
  .w50:last-child {
    padding-left: 20px;
    padding-top: 122px; /* Alineación de título "próximos pasos" */
    padding-right: 50px; /* Evitar ser tapado por flotante ayuda */
  }
  .titulo-detalle {
    margin-top: 0;
  }
}

@media screen and (min-width: 1025px) {
  .og {
    width: 500px;
  }
}
</style>
